import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useBooking } from '../../hooks/useBooking';
import Layout from '../../components/layout/Layout';
import LoginModal from '../../components/auth/LoginModal';
import { PAGES } from '../../utils/constants';

const LoginPage = () => {
  const { closeLoginModal, openRegisterModal } = useAuth();
  const { setCurrentPage } = useBooking();

  const handleClose = () => {
    setCurrentPage(PAGES.HOME);
  };

  const handleSwitchToRegister = () => {
    closeLoginModal();
    openRegisterModal();
    setCurrentPage(PAGES.REGISTER);
  };

  return (
    <Layout>
      <LoginModal 
        onClose={handleClose}
        onSwitchToRegister={handleSwitchToRegister}
      />
    </Layout>
  );
};

export default LoginPage;
